__turbopack_context__.v({
  "error": "index-module-scss-module__djdpzG__error",
  "error-message": "index-module-scss-module__djdpzG__error-message",
  "textarea": "index-module-scss-module__djdpzG__textarea",
});
